// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MCxwu","progress":"styles_progress__A+5fU","progressTitle":"styles_progressTitle__GaAmb"};